export default __webpack_public_path__ + "static/media/AMZN_FR_SH_SD.e1d1b42e.svg";